import { Component, Input } from '@angular/core';

@Component({
  selector: 'address-validation-preview',
  standalone: false,
  templateUrl: './address-validation-preview.component.html',
  styleUrl: './address-validation-preview.component.scss',
})
export class AddressValidationPreviewComponent {
  @Input() isMobile = false;
}
